export const NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME =
  'post_age_to_add_new_user'

export const NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_MAX_LENGTH = 4
